import { makeAutoObservable } from "mobx";
import { Modifier } from "../types/modifier.types";
import { openApi } from "../../../../helpers/request";

class ModifiersController {

    modifiers: Modifier[] = []

    constructor() {
        makeAutoObservable(this)
    }

    GetModifiers() {
        openApi('get', `/modifiers`)
            .then(result => {
                this.modifiers = Array.isArray(result.data) ? [...result.data].reverse() : []
            })
            .catch(err => {
                console.log(err.response)
            })
    }

    DeleteModifier(id: number) {
        openApi('delete', `/modifiers/${id}`)
            .then(() => {
                this.GetModifiers()
            })
            .catch(err => {
                console.log(err.response)
            })
    }

}

export default new ModifiersController()